/* ============================================================
   PRODUCT REVIEWS — comportamento da section
   Lê os dados injetados pelo Liquid e renderiza a lista.
   Suporta múltiplas instâncias da section na mesma página.
   ============================================================ */
(function () {
  'use strict';

  var THUMB_UP =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>';
  var THUMB_DOWN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"/></svg>';

  function localeFor(lang) {
    return lang === 'nl' ? 'nl-NL' : 'de-DE';
  }

  function formatDecimal(value, lang) {
    return Number(value).toFixed(1).replace('.', ',');
  }

  function formatInt(value, lang) {
    return Number(value).toLocaleString(localeFor(lang));
  }

  function stars(rating) {
    var full = Math.round(Number(rating) || 0);
    var out = '';
    for (var i = 0; i < 5; i++) out += i < full ? '★' : '☆';
    return out;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function el(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    return tpl.content.firstElementChild;
  }

  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      console.error('[product-reviews] JSON inválido:', err);
      return null;
    }
  }

  /* ---------- Barra segmentada (qualidade/conforto) ---------- */
  function avgBarHtml(label, value, lang) {
    var full = Math.round(Number(value));
    var segs = '';
    for (var i = 1; i <= 5; i++) {
      segs += '<span class="pr__avg-seg' + (i <= full ? ' is-filled' : '') + '"></span>';
    }
    return (
      '<div class="pr__avg">' +
      '<span class="pr__avg-label">' + escapeHtml(label) + '</span>' +
      '<span class="pr__avg-bar">' + segs + '</span>' +
      '<span class="pr__avg-value">' + formatDecimal(value, lang) + '</span>' +
      '</div>'
    );
  }

  /* ---------- Card de avaliação ---------- */
  function buildCard(review, config) {
    var L = config.labels;
    var lang = config.lang;

    var meta = '';
    if (review.size) meta += '<div><b>' + escapeHtml(L.sizeBought) + ':</b> ' + escapeHtml(review.size) + '</div>';
    if (review.widthPurchased) meta += '<div><b>' + escapeHtml(L.widthBought) + ':</b> ' + escapeHtml(review.widthPurchased) + '</div>';
    if (review.usualSize) meta += '<div><b>' + escapeHtml(L.usualSize) + ':</b> ' + escapeHtml(review.usualSize) + '</div>';

    var ratings = '';
    if (typeof review.quality === 'number') ratings += avgBarHtml(L.quality, review.quality, lang);
    if (typeof review.comfort === 'number') ratings += avgBarHtml(L.comfort, review.comfort, lang);

    var rec = '';
    if (review.recommend === true) {
      rec =
        '<div class="pr__card-rec"><span class="pr__card-rec-check">✓</span>' +
        '<span>' + escapeHtml(L.doesRecommend) + '</span></div>';
    } else if (review.recommend === false) {
      rec =
        '<div class="pr__card-rec is-no"><span class="pr__card-rec-check">✕</span>' +
        '<span>' + escapeHtml(L.notRecommend) + '</span></div>';
    }

    var card = el(
      '<article class="pr__card">' +
        (review.pinned ? '<span class="pr__card-pin">' + escapeHtml(L.pinned) + '</span>' : '') +
        '<div class="pr__card-stars" aria-label="' + review.rating + '/5">' + stars(review.rating) + '</div>' +
        '<h3 class="pr__card-title">' + escapeHtml(review.title) + '</h3>' +
        '<p class="pr__card-author">' + escapeHtml(review.author) + '</p>' +
        (review.verified
          ? '<div class="pr__verified"><span class="pr__verified-dot">✓</span>' + escapeHtml(L.verified) + '</div>'
          : '') +
        '<p class="pr__card-date">' + escapeHtml(review.date) + '</p>' +
        '<p class="pr__card-text">' + escapeHtml(review.text) + '</p>' +
        (meta ? '<div class="pr__card-meta">' + meta + '</div>' : '') +
        (review.photo
          ? '<div class="pr__card-photo"><img src="' + escapeHtml(review.photo) + '" alt="" loading="lazy"></div>'
          : '') +
        rec +
        (ratings ? '<div class="pr__card-ratings">' + ratings + '</div>' : '') +
        '<div class="pr__card-footer">' +
          '<span>' + escapeHtml(L.helpful) + '</span>' +
          '<button type="button" class="pr__helpful-btn" data-vote="yes">' + THUMB_UP +
            ' <span data-count>(' + formatInt(review.helpfulYes || 0, lang) + ')</span></button>' +
          '<button type="button" class="pr__helpful-btn" data-vote="no">' + THUMB_DOWN +
            ' <span data-count>(' + formatInt(review.helpfulNo || 0, lang) + ')</span></button>' +
        '</div>' +
      '</article>'
    );

    var yes = card.querySelector('[data-vote="yes"]');
    var no = card.querySelector('[data-vote="no"]');
    var voted = false;

    function vote(button, key) {
      if (voted) return;
      voted = true;
      review[key] = (review[key] || 0) + 1;
      button.querySelector('[data-count]').textContent = '(' + formatInt(review[key], lang) + ')';
      button.classList.add('is-voted');
      yes.disabled = true;
      no.disabled = true;
    }

    yes.addEventListener('click', function () { vote(yes, 'helpfulYes'); });
    no.addEventListener('click', function () { vote(no, 'helpfulNo'); });

    return card;
  }

  /* ---------- Paginação ---------- */
  function pageNumbers(current, total) {
    var pages = [1];
    for (var i = current - 1; i <= current + 1; i++) {
      if (i > 1 && i < total) pages.push(i);
    }
    if (total > 1) pages.push(total);

    var out = [];
    var prev = 0;
    pages.forEach(function (p) {
      if (prev && p - prev > 1) out.push('gap');
      out.push(p);
      prev = p;
    });
    return out;
  }

  /* ---------- Instância da section ---------- */
  function initSection(root) {
    var sectionId = root.id.replace(/^pr-/, '');
    var dataNode = document.querySelector('[data-pr-data="' + sectionId + '"]');
    var configNode = document.querySelector('[data-pr-config="' + sectionId + '"]');

    var reviews = readJson(dataNode) || [];
    var config = readJson(configNode);
    if (!config) return;

    var listEl = root.querySelector('[data-pr-list]');
    var pagerEl = root.querySelector('[data-pr-pagination]');
    var perPage = config.perPage || 8;
    var page = 1;

    /* Ordena: fixadas primeiro, mantendo a ordem original dentro de cada grupo */
    if (config.pinnedFirst) {
      reviews = reviews
        .map(function (r, i) { return { r: r, i: i }; })
        .sort(function (a, b) {
          var pa = a.r.pinned ? 0 : 1;
          var pb = b.r.pinned ? 0 : 1;
          return pa - pb || a.i - b.i;
        })
        .map(function (x) { return x.r; });
    }

    function renderList() {
      listEl.innerHTML = '';

      if (!reviews.length) {
        listEl.appendChild(el('<div class="pr__empty">' + escapeHtml(config.labels.empty) + '</div>'));
        pagerEl.innerHTML = '';
        return;
      }

      var totalPages = Math.max(1, Math.ceil(reviews.length / perPage));
      if (page > totalPages) page = totalPages;

      reviews.slice((page - 1) * perPage, page * perPage).forEach(function (review) {
        listEl.appendChild(buildCard(review, config));
      });

      renderPager(totalPages);
    }

    function renderPager(totalPages) {
      pagerEl.innerHTML = '';
      if (totalPages <= 1) return;

      function button(label, target, opts) {
        opts = opts || {};
        var btn = el(
          '<button type="button" class="pr__page-btn' + (opts.current ? ' is-current' : '') + '">' + label + '</button>'
        );
        if (opts.disabled) btn.disabled = true;
        if (opts.current) btn.setAttribute('aria-current', 'page');
        btn.addEventListener('click', function () {
          page = target;
          renderList();
          listEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return btn;
      }

      pagerEl.appendChild(button('‹', page - 1, { disabled: page === 1 }));
      pageNumbers(page, totalPages).forEach(function (p) {
        if (p === 'gap') {
          pagerEl.appendChild(el('<span class="pr__page-gap">…</span>'));
        } else {
          pagerEl.appendChild(button(String(p), p, { current: p === page }));
        }
      });
      pagerEl.appendChild(button('›', page + 1, { disabled: page === totalPages }));
    }

    /* Números decimais/milhares no formato do idioma */
    root.querySelectorAll('[data-pr-decimal]').forEach(function (node) {
      node.textContent = formatDecimal(node.getAttribute('data-pr-decimal'), config.lang);
    });
    root.querySelectorAll('[data-pr-number]').forEach(function (node) {
      node.textContent = formatInt(node.getAttribute('data-pr-number'), config.lang);
    });
    root.querySelectorAll('.pr__bar-count').forEach(function (node) {
      var raw = parseInt(node.textContent.replace(/\D/g, ''), 10);
      if (!isNaN(raw)) node.textContent = formatInt(raw, config.lang);
    });

    /* Formulário recolhido: abre pelo botão ou ao escolher uma estrela */
    var formToggle = root.querySelector('[data-pr-form-toggle]');
    var formCollapse = root.querySelector('[data-pr-form-collapse]');

    function openReviewForm(focusFirst) {
      if (!formCollapse || !formCollapse.hidden) return;
      formCollapse.hidden = false;
      if (formToggle) formToggle.hidden = true;
      if (focusFirst) {
        var first = formCollapse.querySelector('input:not([type="hidden"]), textarea');
        if (first) first.focus();
      }
    }

    if (formToggle) {
      formToggle.addEventListener('click', function () { openReviewForm(true); });
    }

    /* Estrelas clicáveis do formulário */
    var formStars = root.querySelector('[data-pr-form-stars]');
    if (formStars) {
      var buttons = Array.prototype.slice.call(formStars.querySelectorAll('.pr__form-star'));
      var ratingInput = root.querySelector('[data-pr-rating-input]');
      var selected = 0;

      function paint(upTo) {
        buttons.forEach(function (b, i) { b.classList.toggle('is-on', i < upTo); });
      }

      buttons.forEach(function (btn, index) {
        btn.addEventListener('mouseenter', function () { paint(index + 1); });
        btn.addEventListener('focus', function () { paint(index + 1); });
        btn.addEventListener('click', function () {
          selected = index + 1;
          paint(selected);
          if (ratingInput) ratingInput.value = String(selected);
          openReviewForm(false);
        });
      });

      formStars.addEventListener('mouseleave', function () { paint(selected); });

      /* Impede envio sem nota, já que o campo é oculto */
      var reviewForm = ratingInput ? ratingInput.closest('form') : null;
      if (reviewForm) {
        reviewForm.addEventListener('submit', function (event) {
          if (!ratingInput.value) {
            event.preventDefault();
            formStars.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (!formStars.nextElementSibling || !formStars.nextElementSibling.classList.contains('pr__form-error')) {
              var msg = el('<p class="pr__form-error">' + escapeHtml(config.labels.pickStars) + '</p>');
              formStars.insertAdjacentElement('afterend', msg);
            }
          }
        });
      }
    }

    /* Carrossel de fotos + lightbox */
    var mediaNode = document.querySelector('[data-pr-media="' + sectionId + '"]');
    var mediaItems = readJson(mediaNode) || [];
    var mediaSection = root.querySelector('[data-pr-media-section]');
    var track = root.querySelector('[data-pr-media-track]');
    var lightbox = root.querySelector('[data-pr-lightbox]');

    if (track && mediaItems.length) {
      mediaSection.hidden = false;

      mediaItems.forEach(function (item, index) {
        var button = el(
          '<button type="button" class="pr__media-item" aria-label="' +
            escapeHtml(item.review ? config.labels.photoOf + ' ' + item.review.author : config.labels.mediaTitle) +
          '">' +
            '<img src="' + escapeHtml(item.src) + '" alt="" loading="lazy">' +
            (item.review ? '<span class="pr__media-badge">' + stars(item.review.rating) + '</span>' : '') +
          '</button>'
        );
        button.addEventListener('click', function () { openLightbox(index); });
        track.appendChild(button);
      });

      var step = 240;
      var prevArrow = root.querySelector('[data-pr-media-prev]');
      var nextArrow = root.querySelector('[data-pr-media-next]');
      if (prevArrow) prevArrow.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
      if (nextArrow) nextArrow.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
    }

    /* ---------- Lightbox ---------- */
    var lbIndex = 0;
    var lbInner = lightbox ? lightbox.querySelector('[data-pr-lightbox-inner]') : null;
    var lbPrev = lightbox ? lightbox.querySelector('[data-pr-lightbox-prev]') : null;
    var lbNext = lightbox ? lightbox.querySelector('[data-pr-lightbox-next]') : null;
    var lbClose = lightbox ? lightbox.querySelector('[data-pr-lightbox-close]') : null;
    var lastFocused = null;

    function renderLightbox() {
      var item = mediaItems[lbIndex];
      if (!item || !lbInner) return;

      var side = '';
      if (item.review) {
        var r = item.review;
        side =
          '<div class="pr__card-stars">' + stars(r.rating) + '</div>' +
          '<h3 class="pr__card-title">' + escapeHtml(r.title) + '</h3>' +
          '<p class="pr__card-author">' + escapeHtml(r.author) + '</p>' +
          (r.verified
            ? '<div class="pr__verified"><span class="pr__verified-dot">✓</span>' + escapeHtml(config.labels.verified) + '</div>'
            : '') +
          '<p class="pr__card-date">' + escapeHtml(r.date) + '</p>' +
          '<p class="pr__card-text">' + escapeHtml(r.text) + '</p>';
      } else {
        side = '<p class="pr__lightbox-empty">' + escapeHtml(config.labels.mediaTitle) + '</p>';
      }

      lbInner.innerHTML =
        '<div class="pr__lightbox-figure"><img src="' + escapeHtml(item.full) + '" alt=""></div>' +
        '<div class="pr__lightbox-side">' + side + '</div>';

      if (lbPrev) lbPrev.disabled = lbIndex === 0;
      if (lbNext) lbNext.disabled = lbIndex === mediaItems.length - 1;
    }

    function openLightbox(index) {
      if (!lightbox) return;
      lastFocused = document.activeElement;
      lbIndex = index;
      renderLightbox();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function stepLightbox(delta) {
      var next = lbIndex + delta;
      if (next < 0 || next >= mediaItems.length) return;
      lbIndex = next;
      renderLightbox();
    }

    if (lightbox) {
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { stepLightbox(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { stepLightbox(1); });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', function (event) {
        if (lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') stepLightbox(-1);
        if (event.key === 'ArrowRight') stepLightbox(1);
      });
    }

    /* Link "X avaliações" rola até a lista */
    var scrollLink = root.querySelector('[data-pr-scroll]');
    if (scrollLink) {
      scrollLink.addEventListener('click', function () {
        listEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    renderList();
  }

  function initAll() {
    document.querySelectorAll('[data-product-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-inicializa quando a section é editada no editor de temas */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-reviews]');
    if (root) initSection(root);
  });
})();